import ApiService from "./api.service";
export default class RbacService extends ApiService {
    static base_url = `${super.base_url}/rbac`;

    static async fetchPermissionsOfRole(role, axiosInstance) {
        const response = await axiosInstance.get(`${this.base_url}/permissions/${role}`);
        return response.data;
    }

    static async getRoles(axiosInstance) {
        const response = await axiosInstance.get(`${this.base_url}/roles`);
        return response.data;
    }

    static async getPermissions(axiosInstance) {
        const response = await axiosInstance.get(`${this.base_url}/permissions`);
        return response.data;
    }

    static async syncRolePermissions(data, axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/role/permissions/sync`, data);
        return response.data;
    }

    static async storeRole(name, axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/roles`, { name });
        return response.data;
    }

    static async fetchManagableModelsOfRole(role, axiosInstance) {
        const response = await axiosInstance.get(`${this.base_url}/role/managable/${role}`);
        return response.data;
    }

    static async destroyRole(role, axiosInstance) {
        const response = await axiosInstance.delete(`${this.base_url}/roles/${role}`);
        return response.data;
    }
}
